import type { PhotoLVPosition } from "@/lib/storage";

export interface OrderedQuotePosition {
  teil?: PhotoLVPosition["teil"];
  posId: string;
  name: string;
  beschreibung?: string;
  qty: number;
  unit: string;
  ep: number;
  total: number;
  variant?: boolean;
}

export function reorderPhotoPositionen(
  positionen: PhotoLVPosition[],
  fromIndex: number,
  toIndex: number,
): PhotoLVPosition[] {
  if (
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= positionen.length ||
    toIndex >= positionen.length ||
    fromIndex === toIndex
  ) {
    return positionen;
  }

  const next = [...positionen];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
}

export function photoPositionenMetadataPatch(positionen: PhotoLVPosition[]) {
  return { photoPositionen: positionen };
}

export function restorePhotoPositionen(value: unknown): PhotoLVPosition[] {
  return Array.isArray(value) ? value as PhotoLVPosition[] : [];
}

export function toQuotePositions(
  positionen: PhotoLVPosition[],
): OrderedQuotePosition[] {
  return positionen
    // Varianten bleiben auch mit Menge 0 sichtbar. Sie dienen als optionale
    // Vergleichspositionen und sollen später direkt aktiviert werden können.
    .filter((position) => position.variant || position.qty > 0)
    .map((position) => ({
      posId: position.id,
      ...(position.teil ? { teil: position.teil } : {}),
      name: position.name,
      ...(position.beschreibung?.trim()
        ? { beschreibung: position.beschreibung.trim() }
        : {}),
      qty: position.qty,
      unit: position.unit,
      ep: position.ep,
      total: position.qty * position.ep,
      ...(position.variant ? { variant: true as const } : {}),
    }));
}